import { createContext, useContext, useReducer } from 'react';

export const ACTIONS = {
    SET_PAGE_VALIDITY: "SET_PAGE_VALIDITY"
}

export const StoreContext = createContext();

const initialState = {
    isPageValid: true
}

function PageValidityReducer(state, action) {
    switch (action.type) {
        case ACTIONS.SET_PAGE_VALIDITY:
            return { ...state, isPageValid: action.payload };
        default:
            return state;
    }
}

export function StoreProvider({ children }) {
    const [state, dispatch] = useReducer(PageValidityReducer, initialState);
    
    return (
        <StoreContext.Provider value={{ state, dispatch }}>
            {children}
        </StoreContext.Provider>
    );
}

